export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6271.f57736a3.jpg";